import {Button} from "@/components/ui/button.tsx";
import {Trash, Plus} from "lucide-react";
import FieldArray from "@/components/form/FieldArray.tsx";
import CurrencyField from "@/components/editor/fields/CurrencyField.tsx";
import Field from "@/components/form/Field.tsx";
import {Fragment} from "react";

export default function LojalitasTokekepzesEditor({name}: { name: string }) {
    return (
        <div className={"grow flex flex-col"}>
            <div className={" grid grid-cols-[1fr_1fr_auto] gap-4 py-4"}>
                <p className={"text-center font-black text-secondary-foreground"}>Főszámla</p>
                <p className={"text-center font-black text-secondary-foreground"}>Eseti számla</p>
                <p className={"text-center font-black text-secondary-foreground"}>Díj</p>
                <FieldArray end={(_)=> {return <>
                    <div className={"flex justify-center col-span-3"}>
                        <Button className={"w-full"} onClick={() => _.add({valuta: {value: 100000, valuta: "HUF"}})}>
                            <Plus/>
                        </Button>
                    </div>
                </>}} name={name}>{(array) => (
                    array.map((_, index) => {
                        return (<Fragment key={_.key}>
                            <CurrencyField name={"valuta"} label={""}/>
                            <CurrencyField name={"eseti"} label={""}/>
                            <div className={"flex gap-2 justify-center"}>
                                <Field name={"netto"} defaultValue={true}>
                                    {(field) => (
                                        <>
                                            <div className={"w-10"}></div>
                                            <Button onClick={() => field.onChange(true)}
                                                    variant={field.value ? "default" : "outline"}>Nettó</Button>
                                            <Button onClick={() => field.onChange(false)}
                                                    variant={!field.value ? "default" : "outline"}>Bruttó</Button>
                                            <div className={"w-10 h-9 "}>
                                                {

                                                    index != 0 &&
                                                    <Button onClick={() => _.remove(index)} className={"w-10 h-9"}
                                                            variant={"outline"}><Trash/></Button>
                                                }
                                            </div>
                                        </>
                                    )}
                                </Field>
                            </div>
                        </Fragment>)
                    })
                )}</FieldArray>
            </div>
            <div className={"grow"}></div>
        </div>
    )
}